import React, {useState} from 'react';
import {Form, Loader} from '@xpertdox_js/xdcomponents';
import styles from './styles';
import csvFile from '../../assets/CTMS-Template.csv';
import {fetchUploads, downloadUpload} from "./fetchers";
import {InstanceContext} from "../../InstanceContext";
import {UserContext} from "../../Context/UserContext";
import UploadsList from "./uploadsList";
import axios from "axios";
import axiosConfig from "../../config/axios.config";
import {trackError} from "../../utils/activityTracker";


const BulkUploads = (props) => {
  const callControl = React.useRef({
    uploads: false
  })
  const [formState, setFormState] = useState({});
  const [error, setError] = useState(false);
  const {contextInstance} = React.useContext(InstanceContext)
  const [processing, setProcessing] = useState(false)
  const { user, userAction } = React.useContext(UserContext);
  const trialInstance = contextInstance || user.instance;

  const [uploads, setUploads] = useState(false)
  if(!uploads && !callControl.current.uploads) {
    callControl.current.uploads = true
    fetchUploads(trialInstance, user.email).then(result => {
      let uploads = {}
      if(result.uploads) uploads.uploads = result.uploads.sort((a,b) => new Date(b.upload_date) - new Date(a.upload_date));
      if(result.analytics) uploads.analytics = result.analytics;
      setUploads(uploads)
    })
  }

  const processParsedData = (data= {}) => {
    // console.log('processParsedData', data);
    setProcessing(true)
    // removed 'axiosConfig.auth' as token is updated on login
    axios.post(
      `${axiosConfig.apiUrl}/rt/console/bulkUpload/${user.email}`,
      {
        data,
        instance: contextInstance || user.instance,
        isBulkUpload: true
      }
    ).then(response => {
      // console.log(response, "RESPONSE")
      setProcessing(false)
      callControl.current.uploads = false;
      setUploads(false)
    }).catch((err) =>{
      // TODO: Handle error
      // setNotification([...notification, { title: 'Error', description: 'File upload failed!', backgroundColor: colors.error }])
      console.log(err)
      trackError({ error: err, history: props.history })
      if (err && err.response && err.response.status === 403) {
        userAction({type: 'logout'})
      }
    })
  }

  const parseFile = (files) => {
    setError(false);
    const file = files[0];
    const fileName = file.name;
    if(!fileName.includes('csv')) {
      setError('Invalid file type! Only csv file formats are supported.');
      return;
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const linesArr = bstr.split(/(?:\r\n|\n)+/);
      const records = [];
      if(linesArr.length < 2) {
        setError("The uploaded file doesn't contain any records.");
        return;
      }
      let headers;
      for (const [index, line] of linesArr.entries()) {
        let rowN = line.split(',').map(p => (p && p || '"_"')).join(',')
        //BREAKS APP ON SAFARI DUE TO LOOKBEHIND REGEX
        let row = rowN.match(/(?<=")[^"]+?(?="(?:\s*?,|\s*?$))|(?<=(?:^|,)\s*?)(?:[^,"\s][^,"]*[^,"\s])|(?:[^,"\s])(?![^"]*?"(?:\s*?,|\s*?$))(?=\s*?(?:,|$))/g)
        if(index === 0) headers = row;
        if (index > 0 && row.length === headers.length) records.push(row)
      };
      processParsedData({headers, records});
    };
    reader.readAsBinaryString(file);
  }

  const handleDrop = (e) => {
    if(e.value.length > 0) parseFile(e.value);
  }

  const formSettings = [{
    type: 'drop',
    callback: handleDrop,
    label: 'Upload csv file',
    id: 'contacts_upload'
  }]

  const handleSubmit = (e) => {
    if(e.value.length > 0) parseFile(e.value);
  }

  return(
    <div style={styles.container}>
      {!props.nonModal && <h4 style={styles.title}>Bulk Upload</h4>}
      {(props.nonModal && uploads)&& <UploadsList uploads={uploads} user={user.email} downloadUpload={downloadUpload} />}
      <div style={styles.content}>
        { error && <div style={{color: 'red', textAlign: 'center', fontSize: '12px'}}><br />{error}</div> }
        <p style={styles.exampleText}>
          <a style={styles.downloadLink} href={csvFile} download>Click Here</a> to download an example csv file.
        </p>
        <p style={styles.exampleText}>
          Instructions for uploading csv file.
        </p>
        <ul style={styles.instructionList}>
          <li style={styles.exampleText}><b>Make sure the data in the columns do not have commas.</b></li>
          <li style={styles.exampleText}><b>NCT_ID</b> refers to the NCT ID of the trial and it is <b>mandatory</b>.</li>
          <li style={styles.exampleText}><b>PROTOCOL_NO</b> refers to the Protocol ID of the trial.</li>
          <li style={styles.exampleText}><b>OPEN_TO_ACCRUAL_DATE</b> refers to the date the trial became 'Open to Accrual'.</li>
          <li style={styles.exampleText}><b>CURRENT_STATUS</b> refers to the current status of the trial.</li>
          <li style={styles.exampleText}><b>PI_FIRST_NAME</b> refers to the first name of Principal Investigator (PI).</li>
          <li style={styles.exampleText}><b>PI_LAST_NAME</b> refers to the last name of Principal Investigator (PI).</li>
          <li style={styles.exampleText}><b>PI_EMAIL</b> refers to the email of Principal Investigator (PI).</li>
          <li style={styles.exampleText}><b>PCRC_FIRST_NAME</b> refers to the first name of Primary Clinical Research Coordinator (PCRC).</li>
          <li style={styles.exampleText}><b>PCRC_LAST_NAME</b> refers to the last name of Primary Clinical Research Coordinator (PCRC).</li>
          <li style={styles.exampleText}><b>PCRC_EMAIL</b> refers to the email of Primary Clinical Research Coordinator (PCRC).</li>
          <li style={styles.exampleText}><b>STUDY_SITE</b> refers to the site of the study.</li>
          <li style={styles.exampleText}><b>ADDITIONAL CONTACT</b> refers to the email of an additional contact.</li>
        </ul>
        {processing && props.nonModal ? <div style={{height: 180}}><Loader/></div> : <Form
          handleSubmit={handleSubmit}
          settings={formSettings}
          state={{formState: formState, setFormState: setFormState}}
          submitText='Upload File'
          submitable={false}
        />}
      </div>
    </div>
  )
}

export default BulkUploads
